/**
 * User: herbert
 * Date: 10.05.16
 * Time: 10:37
 */


// the whole app is presentation only so we disable jsx-ally
/* eslint jsx-a11y/onclick-has-role: 0 */
/* eslint jsx-a11y/img-has-alt: 0 */


import React from 'react';

import steleActions from '../../actions/stele-actions.js';

export default React.createClass({
	propTypes: {
		backCover: React.PropTypes.bool.isRequired,
		parentIdx: React.PropTypes.number.isRequired
	},
	_onClearClick: function () {
		if(this.props.backCover)
			steleActions.toggleBack(this.props.parentIdx);
	},
	_onSetClick: function () {
		if(!this.props.backCover)
			steleActions.toggleBack(this.props.parentIdx);
	},
	render: function () {
		// src={steleSVG.getPart(config.PART_MODUL_AUFNAHME_250_NAME, 0, 1)}
		// src={steleSVG.getPart(config.PART_MODUL_AUFNAHME_250_NAME, 0, 2)}
		return (
				<div className="slx-stele-summary__aufnahme" >
					<div className="slx-stele-summary__optiongroup slx-stele-summary__optiongroup--defaultHeight">
						<div className={this.props.backCover ? 'slx-stele-summary__option' : 'slx-stele-summary__selected'} onClick={this._onClearClick} >
							<img src="img/stele/summary/aufnahme250_Abdeckung_1.svg" className="slx-stele-summary__option-img" />
						</div>
						<div className={this.props.backCover ? 'slx-stele-summary__selected' : 'slx-stele-summary__option'} onClick={this._onSetClick} >
							<img src="img/stele/summary/aufnahme250_Abdeckung_2.svg" className="slx-stele-summary__option-img" />
						</div>
					</div>
				</div>
		);
	}
});
